import Vue from 'vue';

import firebaseUtils from '@/mixins/firebase-utils';

const mutations = {
  SET_DRAFTS: (c, p) => setDrafts(c, p),
  SET_DRAFT: (c, p) => setDraft(c, p),
  SET_DRAFT_BASE_RANKING: (c, p) => setDraftBaseRanking(c, p),
  SET_DRAFT_TEAMS: (c, p) => setDraftTeams(c, p),
  SET_DRAFT_PICKS: (c, p) => setDraftPicks(c, p),
  SET_DRAFT_SETUP: (c, p) => setDraftSetup(c, p),
  ADD_DRAFT: (c, p) => setDraft(c, p),
  SET_ADMIN_OPEN: (c, p) => setAdminOpen(c, p),
  SET_FULL_SCREEN: (c, p) => setFullScreen(c, p),
  DRAFT_PLAYER: (c, p) => draftPlayer(c, p),
  REMOVE_DRAFT: (c, p) => removeDraft(c, p),
  SET_DRAFT_BOARD_HELP: (c, p) => setDraftBoardHelp(c, p),
};

const setDrafts = (state, drafts) => {
  state.drafts = firebaseUtils.arrayFromMap(drafts);
};

const setDraft = (state, draft) => {
  state.draft = draft;
};

const setDraftBaseRanking = (state, baseRanking) => {
  state.draft.baseRanking = baseRanking;
};

const setDraftTeams = (state, teams) => {
  state.draft.teams = teams;
};

const setDraftPicks = (state, picks) => {
  state.draft.picks = picks;
};

const setDraftSetup = (state, {
  teams,
  picks,
  availablePlayers,
  currentPick,
  status,
  lastDrafted,
}) => {
  state.draft.teams = teams;
  state.draft.picks = picks;
  state.draft.availablePlayers = availablePlayers;
  state.draft.currentPick = currentPick;
  state.draft.status = status;
  state.draft.lastDrafted = lastDrafted;
};

const setAdminOpen = (state, open) => {
  state.adminOpen = open;
};

const setFullScreen = (state, fullScreen) => {
  state.fullScreen = fullScreen;
};

const draftPlayer = (state, playerId) => {
  const attemptedPickIndex = state.draft.picks.findIndex(({ p }) => {
    return p === playerId;
  });

  if (attemptedPickIndex === -1) {
    const pick = state.draft.picks[state.draft.currentPick - 1];
    pick.p = playerId;

    Vue.set(state.draft.picks, state.draft.currentPick - 1, pick);
    state.draft.currentPick += 1;
    state.draft.lastDrafted = playerId;
    state.draft.endTime = null;
  }
};

const removeDraft = (state, id) => {
  state.drafts = state.drafts.filter((draft) => {
    return draft.id !== id;
  });
};

const setDraftBoardHelp = (state) => {
  state.seenDraftBoardHelp = true;
};

export default mutations;
